import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { generateDateTicks } from "../../services/dataTicks";

const APEmissions = ({ emission }) => {
  console.log("emission", emission);
  const generateEmissionsData = (numPoints = 100) => {
    const data = [];
    for (let i = 0; i < numPoints; i++) {
      const x = Math.random() * 40;
      const CO2 = parseFloat((12 - 0.2 * x + (Math.random() - 0.5)).toFixed(2));
      const NOx = parseFloat((10 - 0.18 * x + (Math.random() - 0.5)).toFixed(2));
      const SOx = parseFloat((8 - 0.15 * x + (Math.random() - 0.5)).toFixed(2));
      const CO2Eq = parseFloat((15 - 0.25 * x + (Math.random() - 0.5)).toFixed(2));

      data.push({
        x: parseFloat(x.toFixed(2)),
        CO2,
        NOx,
        SOx,
        CO2Eq,
      });
    }
    return data;
  };

  // const emissionsData = generateEmissionsData(100);
  const afterDates = emission?.after_dates || [];
  const beforeDates = emission?.before_dates || [];
  const emissionsDataBefore = emission?.before_additive || generateEmissionsData(100);
  const emissionsDataAfter = emission?.after_additive || generateEmissionsData(100);

  let beforeTickPositions = generateDateTicks(beforeDates);
  let afterTickPositions = generateDateTicks(afterDates);
  console.log("beforeTickPositions", beforeTickPositions);
  console.log("afterTickPositions", afterTickPositions);

  beforeTickPositions  = Array.from(
  new Map(
    beforeTickPositions.map(ts => [
      new Date(ts).toISOString().split("T")[0],
      ts
    ])
  ).values()
);

  afterTickPositions  = Array.from(
  new Map(
    afterTickPositions.map(ts => [
      new Date(ts).toISOString().split("T")[0],
      ts 
    ])
  ).values()
);

  const [chart1Series, setChart1Series] = useState(["CO2", "NOx", "SOx", "CO2Eq"]);
  const [chart2Series, setChart2Series] = useState(["CO2", "NOx", "SOx", "CO2Eq"]);
  const [chart1ShowAll, setChart1ShowAll] = useState(true);
  const [chart2ShowAll, setChart2ShowAll] = useState(true);

  const toggleChart1Series = (series) => {
    setChart1ShowAll(false);
    setChart1Series([series]);
  };

  const toggleChart2Series = (series) => {
    setChart2ShowAll(false);
    setChart2Series([series]);
  };

  const showChart1AllSeries = () => {
    setChart1ShowAll(true);
    setChart1Series(["CO2", "NOx", "SOx", "CO2Eq"]);
  };

  const showChart2AllSeries = () => {
    setChart2ShowAll(true);
    setChart2Series(["CO2", "NOx", "SOx", "CO2Eq"]);
  };

  const createSeriesDataBefore = (selectedSeries) => [
    {
      name: "CO₂",
      data: emissionsDataBefore.map((point) => ({ x: point.x, y: point.CO2 })),
      color: "#1a5276",
      visible: selectedSeries.includes("CO2"),
      marker: { symbol: "circle", radius: 3 },
      showInLegend: false,
    },
    {
      name: "NOx",
      data: emissionsDataBefore.map((point) => ({ x: point.x, y: point.NOx })),
      color: "#d35400",
      visible: selectedSeries.includes("NOx"),
      marker: { symbol: "square", radius: 3 },
      showInLegend: false,
    },
    {
      name: "SOx",
      data: emissionsDataBefore.map((point) => ({ x: point.x, y: point.SOx })),
      color: "#27ae60",
      visible: selectedSeries.includes("SOx"),
      marker: { symbol: "triangle", radius: 3 },
      showInLegend: false,
    },
    {
      name: "CO₂ Eq",
      data: emissionsDataBefore.map((point) => ({ x: point.x, y: point.CO2Eq })),
      color: "#7d3c98",
      visible: selectedSeries.includes("CO2Eq"),
      marker: { symbol: "diamond", radius: 3 },
      showInLegend: false,
    },
  ];

  const createSeriesDataAfter = (selectedSeries) => [
    {
      name: "CO₂",
      data: emissionsDataAfter.map((point) => ({ x: point.x, y: point.CO2 })),
      color: "#1a5276",
      visible: selectedSeries.includes("CO2"),
      marker: { symbol: "circle", radius: 3 },
      showInLegend: false,
    },
    {
      name: "NOx",
      data: emissionsDataAfter.map((point) => ({ x: point.x, y: point.NOx })),
      color: "#d35400",
      visible: selectedSeries.includes("NOx"),
      marker: { symbol: "square", radius: 3 },
      showInLegend: false,
    },
    {
      name: "SOx",
      data: emissionsDataAfter.map((point) => ({ x: point.x, y: point.SOx })),
      color: "#27ae60",
      visible: selectedSeries.includes("SOx"),
      marker: { symbol: "triangle", radius: 3 },
      showInLegend: false,
    },
    {
      name: "CO₂ Eq",
      data: emissionsDataAfter.map((point) => ({ x: point.x, y: point.CO2Eq })),
      color: "#7d3c98",
      visible: selectedSeries.includes("CO2Eq"),
      marker: { symbol: "diamond", radius: 3 },
      showInLegend: false,
    },
  ];

  const createChartOptions = (tickPositions) => ({

    chart: {
      type: "scatter",
      zooming: { type: "xy" },
      height: "400px",
      style: {
        fontFamily: "Inter, sans-serif",
      },
    },
    title: { text: null },

    xAxis: {
      type: "datetime",
      title: { text: null },
      min: tickPositions[0],              // Start date
      max: tickPositions[tickPositions.length - 1], // End date
      tickPositions: tickPositions, 
      gridLineWidth: 1,
      gridLineColor: "#eee",
      labels: {
        format: "{value:%b %d}",
        style: { fontSize: "14px", fontWeight: 600, color: "#495057"},
      },
    },
    yAxis: {
      title: { text: "Emission (MT / Day)" },
      gridLineColor: "#eee",
      labels: {
        step: 1,
        style: { fontSize: "14px", fontWeight: 600, color: "#495057" },
      },
    },
    tooltip: {
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderRadius: 8,
      useHTML: true,
      formatter: function () {
        const date = new Date(this.x); // `this.x` is the timestamp
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
        });
        return `
      <b>${this.series.name}</b><br/>
      Date: ${formattedDate}<br/>
      Consumption: <b>${this.y.toFixed(2)}</b> MT
    `;
      },
    },

    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 6,
          symbol: "circle",
          states: { hover: { enabled: true, lineColor: "#333" } },
        },
      },
    },
    credits: { enabled: false },

  })

  const options = {

  };


  return (
    <div className="p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Chart 1 */}
        <div>
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-4">
            <HighchartsReact
              highcharts={Highcharts}
              options={{ ...createChartOptions(beforeTickPositions), series: createSeriesDataBefore(chart1Series) }}
            />
          </div>

          {/* Buttons */}
          <div className="flex space-x-4 mt-4 justify-center flex-wrap">
            <button
              onClick={showChart1AllSeries}
              className={`px-3 py-1 rounded-full flex items-center ${chart1ShowAll ? "bg-[#1a5276] text-white" : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-full bg-gray-400 mr-2"></span>
              All
            </button>
            <button
              onClick={() => toggleChart1Series("CO2")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart1ShowAll && chart1Series.includes("CO2")
                  ? "bg-[#1a5276] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-full bg-[#1a5276] mr-2"></span>
              CO₂
            </button>
            <button
              onClick={() => toggleChart1Series("NOx")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart1ShowAll && chart1Series.includes("NOx")
                  ? "bg-[#d35400] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-sm bg-[#d35400] mr-2"></span>
              NOx
            </button>
            <button
              onClick={() => toggleChart1Series("SOx")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart1ShowAll && chart1Series.includes("SOx")
                  ? "bg-[#27ae60] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-sm bg-[#27ae60] mr-2 transform rotate-45"></span>
              SOx
            </button>
            <button
              onClick={() => toggleChart1Series("CO2Eq")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart1ShowAll && chart1Series.includes("CO2Eq")
                  ? "bg-[#7d3c98] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-sm bg-[#7d3c98] mr-2"></span>
              CO₂ Eq
            </button>
          </div>

          {/* Y-axis Label */}
          <div className="text-center my-3">
            <span className="font-bold text-[14px] text-[#495057] tracking-wide">
              Emissions (MT/day)
            </span>
          </div>
        </div>

        {/* Chart 2 */}
        <div>
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-4">
            <HighchartsReact
              highcharts={Highcharts}
              options={{ ...createChartOptions(afterTickPositions), series: createSeriesDataAfter(chart2Series) }}
            />
          </div>

          {/* Buttons */}
          <div className="flex space-x-4 mt-4 justify-center flex-wrap">
            <button
              onClick={showChart2AllSeries}
              className={`px-3 py-1 rounded-full flex items-center ${chart2ShowAll ? "bg-[#1a5276] text-white" : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-full bg-gray-400 mr-2"></span>
              All
            </button>
            <button
              onClick={() => toggleChart2Series("CO2")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart2ShowAll && chart2Series.includes("CO2")
                  ? "bg-[#1a5276] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-full bg-[#1a5276] mr-2"></span>
              CO₂
            </button>
            <button
              onClick={() => toggleChart2Series("NOx")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart2ShowAll && chart2Series.includes("NOx")
                  ? "bg-[#d35400] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-sm bg-[#d35400] mr-2"></span>
              NOx
            </button>
            <button
              onClick={() => toggleChart2Series("SOx")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart2ShowAll && chart2Series.includes("SOx")
                  ? "bg-[#27ae60] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-sm bg-[#27ae60] mr-2 transform rotate-45"></span>
              SOx
            </button>
            <button
              onClick={() => toggleChart2Series("CO2Eq")}
              className={`px-3 py-1 rounded-full flex items-center ${!chart2ShowAll && chart2Series.includes("CO2Eq")
                  ? "bg-[#7d3c98] text-white"
                  : "bg-gray-100"
                }`}
            >
              <span className="w-3 h-3 rounded-sm bg-[#7d3c98] mr-2"></span>
              CO₂ Eq
            </button>
          </div>

          {/* Y-axis Label */}
          <div className="text-center my-3">
            <span className="font-bold text-[14px] text-[#495057] tracking-wide">
              Emissions (MT/day)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APEmissions;